import { createReducer, on } from '@ngrx/store';
import { loadKioskGlobalSettings } from './kiosk-global-settings.action';
import {
  KioskGlobalSettingsState,
  KIOSK_GLOBAL_SETTINGS_INITIAL_STATE,
} from './kiosk-global-settings.state';
import { MultiCurrencyMode } from '@core/models/kiosk-global-settings.model';
import { normalizeKioskGlobalSettings } from './normalize-kiosk-global-settings';

export const KIOSK_GLOBAL_SETTINGS_STORE_REDUCER = createReducer(
  KIOSK_GLOBAL_SETTINGS_INITIAL_STATE,
  on(loadKioskGlobalSettings, (state, { settings }): KioskGlobalSettingsState => {
    return {
      ...state,
      settings: normalizeKioskGlobalSettings(settings),
    };
  }),
);

export function readMultiCurrencyMode(
  settings: { multiCurrency?: { mode?: unknown } } | undefined,
): MultiCurrencyMode {
  const record = settings as Record<string, unknown> | undefined;
  const camelMode = asMultiCurrencyMode(settings?.multiCurrency);
  if (camelMode !== 'off') {
    return camelMode;
  }
  return asMultiCurrencyMode(record?.['multi_currency']);
}

function asMultiCurrencyMode(value: unknown): MultiCurrencyMode {
  const mode = value && typeof value === 'object' ? (value as { mode?: unknown }).mode : undefined;
  if (mode === 'sco' || mode === 'test') {
    return mode;
  }
  return 'off';
}
